<template>
    <svg :width="width" :height="height" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1905_124735)">
            <path d="M0.833984 6.55064C0.834264 7.87785 1.29428 9.16392 2.13566 10.1897C2.97704 11.2155 4.14772 11.9176 5.44826 12.1763C5.52233 11.3545 5.733 10.551 6.07159 9.7987C5.06784 9.45922 4.42273 8.68849 4.27148 7.59433H3.69857V7.10575H4.23253V6.60798C4.23253 6.55523 4.23253 6.50132 4.23711 6.45315H3.69857V5.96342H4.28409C4.5419 4.53207 5.66138 3.68335 7.34346 3.68335C7.70555 3.68335 8.0195 3.7189 8.2819 3.78084V4.62153C7.97543 4.55328 7.66195 4.52171 7.34805 4.52748C6.29503 4.52748 5.58575 5.06194 5.36117 5.96342H7.55773V6.45315H5.28898C5.28555 6.50591 5.28555 6.5644 5.28555 6.62175V7.10575H7.55773V7.59548H5.33711C5.47232 8.28592 5.87336 8.7768 6.48867 9.00504C7.092 8.00488 7.92173 7.16067 8.91093 6.54048C9.90014 5.9203 11.0211 5.54152 12.1835 5.43469C11.9024 4.04177 11.115 2.80282 9.97353 1.95783C8.8321 1.11284 7.41798 0.721944 6.00509 0.860868C4.5922 0.999791 3.2811 1.65865 2.32576 2.70981C1.37042 3.76096 0.838839 5.12961 0.833984 6.55064ZM19.1673 12.8587C19.1673 14.5317 18.5033 16.1361 17.3215 17.3191C16.1396 18.5021 14.5366 19.1667 12.8652 19.1667C11.1938 19.1667 9.59086 18.5021 8.40899 17.3191C7.22712 16.1361 6.56315 14.5317 6.56315 12.8587C6.56315 11.1857 7.22712 9.5812 8.40899 8.39822C9.59086 7.21523 11.1938 6.55064 12.8652 6.55064C14.5366 6.55064 16.1396 7.21523 17.3215 8.39822C18.5033 9.5812 19.1673 11.1857 19.1673 12.8587ZM10.2871 14.3749C10.3662 15.3326 11.1419 16.0781 12.5375 16.1664V16.8729H13.1563V16.1618C14.5989 16.0632 15.4434 15.3131 15.4434 14.2235C15.4434 13.2314 14.7983 12.721 13.6444 12.4573L13.1563 12.3426V10.4203C13.775 10.4891 14.1692 10.8183 14.2632 11.2748H15.3494C15.2692 10.3527 14.4568 9.63125 13.1563 9.55212V8.84447H12.5375V9.56588C11.3046 9.68401 10.4659 10.4054 10.4659 11.4262C10.4659 12.3288 11.0892 12.9034 12.1273 13.1385L12.5375 13.236V15.2775C11.9027 15.1858 11.4834 14.8463 11.3883 14.3749H10.2871ZM12.5329 12.2015C11.9234 12.0639 11.5934 11.784 11.5934 11.3619C11.5934 10.8917 11.9497 10.5373 12.5375 10.4341V12.2003H12.5318L12.5329 12.2015ZM13.2457 13.3989C13.9847 13.5652 14.3262 13.8347 14.3262 14.3118C14.3262 14.8555 13.9022 15.2293 13.1574 15.2982V13.3782L13.2457 13.3989Z" :fill="iconColor"/>
        </g>
        <defs>
            <clipPath id="clip0_1905_124735">
                <rect width="20" height="20" fill="white"/>
            </clipPath>
        </defs>
    </svg>
  </template>
  
  <script>
  export default {
    props: {
      iconName: {
        type: String,
        default: "IconCurrencyForex",
      },
      width: {
        type: [Number, String],
        default: 20,
      },
      height: {
        type: [Number, String],
        default: 20,
      },
      iconColor: {
        type: String,
        default: "black",
      },
    },
  };
  </script>
  